export default {
    meter: 'meter',
    kilometer: 'kilometer',
    yard: 'yard',
    mile: 'mile',
    inch: 'inch',
    nauticalMile: 'nauticalMile'
};
